export const ESCALADO_DISTANCIA_EN_X = 1
export const ESCALADO_DISTANCIA_EN_Y = 1

const SILO_GRANDE = {
  topConeHeight: 3,
  bottomConeHeight: 0
}
const SILO_CHICO = {
  topConeHeight: 0,
  bottomConeHeight: 2.2
}
const ENTRSILO = {
  topConeHeight: 0,
  bottomConeHeight: 0
}

export const TIPOS_SILO = {
  SILO_GRANDE: 'SILO_GRANDE',
  SILO_CHICO: 'SILO_CHICO',
  ENTRESILO: 'ENTRSILO'
}

const S1 = {
  color: 'a8a8a8',
  transparency: '0.9',
  startingXPosition: 0 * ESCALADO_DISTANCIA_EN_X,
  xLarge: 90 * ESCALADO_DISTANCIA_EN_X,
  startingZPosition: 0,
  zLarge: 18
}

const S2 = {
  color: 'a8a8a8',
  transparency: '0.9',
  startingXPosition: 90 * ESCALADO_DISTANCIA_EN_X,
  xLarge: 60 * ESCALADO_DISTANCIA_EN_X,
  startingZPosition: 0,
  zLarge: 18
}

const S5 = {
  color: 'a8a8a8',
  transparency: '0.9',
  startingXPosition: 150 * ESCALADO_DISTANCIA_EN_X,
  xLarge: 18 * ESCALADO_DISTANCIA_EN_X,
  startingZPosition: 0,
  zLarge: 18
}

export const TORRE1 = {
  color: 'a8a8a8',
  transparency: 0.5,
  altura: 60,
  startingXPosition: 150 * ESCALADO_DISTANCIA_EN_X,
  xLarge: 56 * ESCALADO_DISTANCIA_EN_X,
  startingZPosition: 0,
  zLarge: 18
}

const S3 = {
  color: 'a8a8a8',
  transparency: '0.9',
  startingXPosition: 206 * ESCALADO_DISTANCIA_EN_X,
  xLarge: 60 * ESCALADO_DISTANCIA_EN_X,
  startingZPosition: 0,
  zLarge: 18
}

export const TORRE2 = {
  color: 'a8a8a8',
  transparency: 0.5,
  altura: 70,
  startingXPosition: 266 * ESCALADO_DISTANCIA_EN_X,
  xLarge: 15 * ESCALADO_DISTANCIA_EN_X,
  startingZPosition: 0,
  zLarge: 18
}

const S4 = {
  color: 'a8a8a8',
  transparency: '0.9',
  startingXPosition: 281 * ESCALADO_DISTANCIA_EN_X,
  xLarge: 60 * ESCALADO_DISTANCIA_EN_X,
  startingZPosition: 0,
  zLarge: 18
}

export const LARGO_ELEVADOR = 341 * ESCALADO_DISTANCIA_EN_X
export const RELACION_LARGO_ELEVADOR_SILO_CHICO_RADIO = 1 / 10
export const ALTO_ELEVADOR = 20 * ESCALADO_DISTANCIA_EN_Y

// const S5 = {
//   color: 'a8a8a8',
//   transparency: '0.9',
//   startingXPosition: -1,
//   xLarge: -1,
//   startingZPosition: -1,
//   zLarge: -1
// }

export const TIPO_POR_SECTOR = {
  S1: 'CHICO_ENTRESILO',
  S2: 'CHICO_ENTRESILO',
  S3: 'CHICO_ENTRESILO',
  S4: 'GRANDE',
  S5: 'CHICO_ENTRESILO'
}

export const SILOS = {
  SILO_GRANDE,
  SILO_CHICO,
  ENTRSILO
}
export const SECTORES_SIN_TORRES = {
  S1: { ...S1, startingZPosition: 3 },
  S2: { ...S2, startingZPosition: 3 },
  S5: { ...S5, startingXPosition: -5, xLarge: S5.xLarge * 2, startingZPosition: 6 + S5.startingZPosition + S5.zLarge + 1 },
  S3: { ...S3, startingXPosition: S5.xLarge * 2 + 6, startingZPosition: 6 + S3.startingZPosition + S3.zLarge + 1 },
  S4: { ...S4, startingXPosition: S5.xLarge + 12 + S3.xLarge, xLarge: S4.xLarge, startingZPosition: 6 + S3.startingZPosition + S3.zLarge + 1 }
}

export const SECTORES_SIN_TORRES_PARA_CEREAL_POR_LINEA = {
  S1,
  S2,
  S3: { ...S3, startingXPosition: S3.startingXPosition + 1 - (TORRE1.xLarge) },
  S4: { ...S4, startingXPosition: S4.startingXPosition + 2 - (TORRE1.xLarge + TORRE2.xLarge) }
}

export const SECTORES = {
  S1,
  S2,
  S5,
  S3,
  S4
}

const N1S2 = {
  color: '#0043ce'
}
const N1S3 = {
  color: '#005d5d'
}
const N2S2 = {
  color: '#6929c4'
}
const N2S3 = {
  color: '#a2191f'
}
const N3S2 = {
  color: '#198038'
}
const N3S3 = {
  color: '#0072c3'
}
const N4S3 = {
  color: '#9f1853'
}

export const NUCLEOS = {
  N1S2,
  N1S3,
  N2S2,
  N2S3,
  N3S2,
  N3S3,
  N4S3
}
